import {
  ActionAttributeTypes,
  ActionNames,
  NotificationTemplate,
  WorkflowActionData,
  WorkflowActionInfo,
} from "lib/api";

const getActionTypeRecipientsListKey = (
  actionType: WorkflowActionInfo
): string | null => {
  switch (actionType.action_name) {
    case ActionNames.NotificationEmail:
      return ActionAttributeTypes.Email;
    case ActionNames.NotificationPush:
      return ActionAttributeTypes.Id;
    case ActionNames.NotificationSms:
      return ActionAttributeTypes.Number;
    default:
      return null;
  }
};

export const getActionRecipientsList = (
  action?: WorkflowActionData,
  actionType?: WorkflowActionInfo
): Array<Partial<User>> => {
  if (actionType != null && action != null) {
    const listKey = getActionTypeRecipientsListKey(actionType);
    const list =
      listKey && actionType.attributes?.[listKey]?.type === "array"
        ? action.attributes?.[listKey]?.value
        : undefined;

    if (list != null && Array.isArray(list)) {
      return list;
    }
  }

  return [];
};

export const setActionRecipientsList = (
  action: WorkflowActionData,
  actionType: WorkflowActionInfo,
  recipients: Array<Partial<User>>
): void => {
  if (actionType != null && action != null) {
    const listKey = getActionTypeRecipientsListKey(actionType);

    if (listKey != null) {
      const attribute = actionType.attributes[listKey];
      // eslint-disable-next-line no-param-reassign
      action.attributes[listKey] = { ...attribute, value: recipients };
    }
  }
};

export const actionIsInvalid = (
  action: WorkflowActionData,
  templatesEmail: NotificationTemplate[] | undefined,
  templatesPush: NotificationTemplate[] | undefined,
  templatesSms: NotificationTemplate[] | undefined
): [boolean, string | undefined] => {
  const isCreateIncidentAction = action.incident_data != null;

  let templateData = null;
  if (action.name === ActionNames.NotificationEmail) {
    templateData = templatesEmail as NotificationTemplate[];
  } else if (action.name === ActionNames.NotificationPush) {
    templateData = templatesPush as NotificationTemplate[];
  } else if (action.name === ActionNames.NotificationSms) {
    templateData = templatesSms as NotificationTemplate[];
  }
  const template = !isCreateIncidentAction
    ? templateData?.find(
        (tpl) =>
          tpl.id === action.notification_template_id && (tpl.active ?? true)
      )
    : undefined;

  const invalid = !isCreateIncidentAction && !template;
  return [invalid, template?.name];
};
